var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-steps"},[_c('router-link',{attrs:{"to":{
      name: 'RegisterPage1',
      params: { lang: _vm.$i18n.locale },
      query: Object.assign({}, _vm.$route.query)
    }}},[_c('Icon',{staticClass:"icon",attrs:{"icon":"ix:user-profile-filled"}}),_vm._v("\n    "+_vm._s(_vm.$t("register.steps.0"))+"\n  ")],1),_c('router-link',{attrs:{"to":{
      name: 'RegisterPage2',
      params: { lang: _vm.$i18n.locale },
      query: Object.assign({}, _vm.$route.query)
    }}},[_c('Icon',{staticClass:"icon",attrs:{"icon":"material-symbols:domain-rounded"}}),_vm._v("\n    "+_vm._s(_vm.$t("register.steps.1"))+"\n  ")],1),_c('router-link',{attrs:{"to":{
      name: 'RegisterPage3',
      params: { lang: _vm.$i18n.locale },
      query: Object.assign({}, _vm.$route.query)
    }}},[_c('Icon',{staticClass:"icon",attrs:{"icon":"material-symbols:interests"}}),_vm._v("\n\n    "+_vm._s(_vm.$t("register.steps.2"))+"\n  ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }